import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useAuth } from 'react-oidc-context';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { GET_PROJECTS } from 'graphql/project';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider, {
  useAdvanceTableContext
} from 'providers/AdvanceTableProvider';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';

const columns = [
  {
    accessorKey: 'name',
    header: 'Name',
    meta: {
      headerProps: { className: 'text-900' }
    }
  },
  {
    accessorKey: 'description',
    header: 'Description',
    meta: {
      headerProps: { className: 'text-900' }
    }
  },
  {
    accessorKey: 'georeferences',
    header: 'Geoferences',
    meta: {
      headerProps: { className: 'text-900' }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    meta: {
      headerProps: { className: 'text-900' }
    }
  },
  {
    accessorKey: 'status',
    header: 'Status',
    meta: {
      headerProps: { className: 'text-900' }
    }
  }
];

function BulAction({ toggleModal }) {
  const navigate = useNavigate();
  const { getSelectedRowModel } = useAdvanceTableContext();
  // const selectedRows = getSelectedRowModel().rows;

  // Ensure only one row is selected at a time
  // useEffect(() => {
  //   if (selectedRows.length > 0) {
  //     const lastIndex = selectedRows.length - 1;
  //     const lastRow = selectedRows[lastIndex].id;
  //     setRowSelection({ [lastRow]: true }); // Keep only the last row selected
  //   }
  //   // setRowSelection([]);

  //   // Update the selection with the clicked row
  //   // setRowSelection([selectedRows]);
  // }, [selectedRows, setRowSelection]);
  const handleToggleModal = () => {
    toggleModal();
  };

  const handleNavigateToSummaryReport = rowLength => {
    if (rowLength == 1) {
      navigate('/reporting-module');
    } else {
      navigate('/summary-report-comparison');
    }
  };

  return (
    <Row className="flex-between-center mb-3">
      <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
        <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
          {getSelectedRowModel().rows.length > 0
            ? 'You have selected ' +
              getSelectedRowModel().rows.length +
              ' project(s)'
            : 'You have not selected any project.'}
        </h5>
      </Col>
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
        {getSelectedRowModel().rows.length > 0 ? (
          <div className="d-flex">
            <IconButton
              type="button"
              className="ms-2"
              icon="external-link-alt"
              onClick={() =>
                handleNavigateToSummaryReport(getSelectedRowModel().rows.length)
              }
            >
              Reporting Module
            </IconButton>
          </div>
        ) : (
          <div id="orders-actions">
            <IconButton
              icon="plus"
              transform="shrink-3"
              className="me-2"
              onClick={() => handleToggleModal(getSelectedRowModel().rows)}
            >
              <span className="d-none d-sm-inline-block ms-1">
                Create a Project
              </span>
            </IconButton>
          </div>
        )}
      </Col>
    </Row>
  );
}

BulAction.propTypes = {
  toggleModal: PropTypes.func.isRequired
};

const ProjectTable = ({ toggleModal }) => {
  const auth = useAuth();
  const [projects, setProjects] = useState([]);

  const { data } = useQuery(GET_PROJECTS, {
    variables: {
      createdBy: auth.user.profile.sub
    }
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    setProjects(data.projects.items);
  }, [data]);

  const table = useAdvanceTable({
    data: projects,
    columns,
    sortable: true,
    selection: true,
    pagination: true,
    perPage: 5,
    selectionColumnWidth: 30
  });

  return (
    <AdvanceTableProvider {...table}>
      <BulAction toggleModal={toggleModal} />
      <AdvanceTable
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          striped: true,
          className: 'fs-10 mb-0'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter rowInfo navButtons />
      </div>
    </AdvanceTableProvider>
  );
};

ProjectTable.propTypes = {
  toggleModal: PropTypes.func.isRequired
};

export default ProjectTable;
